import { atom, useAtomValue, useSetAtom } from 'jotai';
import { secureHttpClient } from '../restClient';
import { useGetMerchantConfigurationOptions } from './configManager';

const PinScreenOpen = atom(false);

export const useGetPinScreenOpen = () => useAtomValue(PinScreenOpen);
export const useSetPinScreenOpen = () => useSetAtom(PinScreenOpen);

export const useVerifyPIN = () => {
  return async (pin: string) => {
    try {
      const verified = await secureHttpClient.postOperate<boolean>(
        {
          fileName: 'flowManager.ts',
          fetchingFunction: 'useVerifyPIN',
        },
        `api/peers-apps/verify-pin`,
        { pin },
      );
      return verified;
    } catch (e) {
      return;
    }
  };
};

export const useOpenPinScreen = () => {
  const configOptions = useGetMerchantConfigurationOptions();
  const setPinScreenOpen = useSetPinScreenOpen();
  return (isModalDisplayed: boolean) => {
    if (configOptions.pin && !isModalDisplayed) {
      setPinScreenOpen(true);
    }
  };
};

export const setFirstLoadAfterLogin = (value: boolean) =>
  sessionStorage.setItem('firstLoadAfterLogin', JSON.stringify(value));

export const getFirstLoadAfterLogin = () =>
  JSON.parse(sessionStorage.getItem('firstLoadAfterLogin') ?? 'false');
